<template>
  <div v-if="form.status === '1'" class="row">
    <div class="col-lg-10 offset-lg-1">
      <div class="card">
        <form @submit.prevent="save">
          <div class="list-group list-group-flush">
            <div class="list-group-item text-center py-3">
              <img src="@/assets/img/logo_nextgen.png" class="h-72px" />
              <h3 class="mb-0">{{ form.title }}</h3>
            </div>
            <div v-if="form.video">
              <div class="text-center">
                <video
                  :src="baseUrl + '/' + form.video"
                  controls
                  playsinline
                  controlsList="nodownload"
                  class="w-100"
                  @ended="showForm = true"
                >
                  Seu navegador não suporta vídeos HTML5.
                </video>
              </div>
            </div>
            <template
              v-for="(question, index) in form.questions"
              :key="question.id"
            >
              <div v-if="showForm" class="list-group-item py-3">
                <p class="fw-bold">{{ index + 1 }}) {{ question.text }}</p>
                <img
                  v-if="question.image"
                  :src="question.image"
                  class="img-fluid mb-3"
                />
                <label
                  v-for="option in question.options"
                  :key="option.id"
                  class="form-check cp mb-2"
                >
                  <input
                    type="radio"
                    class="form-check-input"
                    :id="`question${question.id}${index}`"
                    :value="option.id"
                    v-model="question.optionSelected"
                  />
                  <span class="form-check-label">
                    {{ option.text }}
                    <img
                      v-if="option.image"
                      :src="option.image"
                      class="img-fluid mb-3"
                    />
                  </span>
                </label>
              </div>
            </template>
            <div class="list-group-item text-center py-3">
              <button
                v-if="showForm"
                type="submit"
                class="btn btn-primary w-size"
                title="Salvar"
                :disabled="disableButton"
              >
                <span v-if="disableButton">
                  <i class="ph ph-spinner spinner" />
                </span>
                <span v-else>Salvar</span>
              </button>
              <hr />
              <div class="text-center" title="Cancelar">
                <router-link to="/">Cancelar</router-link>
              </div>
              <p class="mt-2 mb-0 text-center">Powered by Ethos</p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-else class="card p-4">
    <div class="flex-fill text-center">
      <img src="@/assets/img/logo_nextgen.png" class="h-80px" />
      <h5 class="my-3">As respostas para este formulário foram encerradas</h5>
      <router-link to="/" class="btn btn-primary w-50" title="OK">
        OK
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Questions',

  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showForm: false,
      disableButton: false,
      baseUrl: `${process.env.VUE_APP_BASE_URL_API}/uploads/forms/${this.form.id}/video`,
    }
  },

  methods: {
    async save() {
      const allQuestionsSelected = this.form.questions.filter(
        (question) => question.optionSelected === null,
      )

      if (allQuestionsSelected.length > 0) {
        this.$root.$refs.notification.warning(
          'Por favor, responda todas as perguntas antes de continuar.',
        )
        return
      }

      const answers = {
        questions: this.form.questions.map((question) => {
          return {
            id: question.id,
            optionId: question.optionSelected,
          }
        }),
      }

      this.disableButton = true
      try {
        const response = await this.$store.dispatch('createAnswers', {
          code: this.form.code,
          answers,
        })
        this.$root.$refs.notification.success(response.message)

        if (this.form.competitive === '1') {
          this.$router.push({ name: 'Thanks' })
        } else {
          this.$router.push({
            name: 'Results',
            params: { code: this.form.code },
          })
        }
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.showForm = !this.form.video
  },
}
</script>

<style scoped>
.w-size {
  width: 100% !important;
}

@media (min-width: 768px) {
  .w-size {
    width: 50% !important;
  }
}

@media (min-width: 992px) {
  .w-size {
    width: 35% !important;
  }
}

@media (min-width: 1200px) {
  .w-size {
    width: 20% !important;
  }
}
</style>
